import { Container, Heading, Spacer, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { maintenanceMode, maintenanceReason } from '../config';
import { styled } from '../Stitches';

const Purple = styled('span', { color: '$ldPurple' });

const MaintenanceView = () => (
  <Container p={[4, 8, 12]}>
    <Spacer h={[0, 8, 12]} />
    <Stack>
      <Heading fontFamily={'heading'} fontWeight="medium">
        <Purple>LetterDesk</Purple> is currently undergoing planned maintenance.
      </Heading>
      <Text fontFamily={'mono'}>We appreciate your patience. Please try again soon.</Text>
      <Spacer />
      {maintenanceReason && (
        <Text fontSize={'xs'} fontFamily={'mono'}>
          Maintenance reason: {maintenanceReason}
        </Text>
      )}
    </Stack>
  </Container>
);

const Maintenance = ({ children }: { children: React.ReactNode }) => {
  const maintenance = maintenanceMode === 'true';

  return maintenance ? <MaintenanceView /> : <>{children}</>;
};

export default Maintenance;
